import React from "react";
import { languages } from "../constants/languages";
import tournamentPicture from "../img/tournament.png";
import Typography from "@material-ui/core/Typography";
import CreateTournamentContainer from "../containers/CreateTournamentContainer";

const NoTournamentsMessage = props => (
  <div style={{ width: "95%", textAlign: "center", marginBottom: 20 }}>
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <img
        src={tournamentPicture}
        alt=""
        style={{ height: 100, margin: "20px 0 15px 0" }}
      />
      <Typography variant="h6">
        {languages.createTournament.noTournamentsMessageTitle}
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: 17 }}>
        {languages.createTournament.noTournamentsMessageDescription}
      </Typography>
      <div style={{ marginTop: 15 }}>
        <CreateTournamentContainer
          user={props.user}
          userData={props.userData}
        />
      </div>
    </div>
  </div>
);

export default NoTournamentsMessage;
